var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "l2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 203.01 59.41"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:url(#l35);}.cls-2{fill:url(#l54);}.cls-3{fill:url(#l35-2);}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l35",
    x1: 1.28,
    y1: 26.41,
    x2: 21.82,
    y2: 58.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#631101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#bb1e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f95c04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#feb400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9d776"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l54",
    x1: 40.69,
    y1: 25.12,
    x2: 20.01,
    y2: 57.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#631101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#bb1e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#f95c04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#feb400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#e9d776"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l35-2",
    x1: 20.27,
    y1: 7.36,
    x2: 20.27,
    y2: 56.38,
    xlinkHref: "#l35"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.86,60.54S-11,50,7,17.24c0,0-1.7,11.38,1.27,18.25S15.32,48.23,17.86,60.54Z",
    transform: "translate(-1.09 -1.22)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.87,60.63a27.09,27.09,0,0,0,9.48-5.94A26.35,26.35,0,0,0,39,44.32a27,27,0,0,0,.09-15.7,32.78,32.78,0,0,0-5-10.87,42.37,42.37,0,0,1-1.53,16c-1.36,4.5-2.88,6.57-5.18,12.22A88.29,88.29,0,0,0,22.87,60.63Z",
    transform: "translate(-1.09 -1.22)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.41,50.41c1.05,0,1.72-2.24,3.62-7.13,1.22-3.13,1.71-3.93,2.24-5.45a38,38,0,0,0,1.5-5.08,43.74,43.74,0,0,0-.11-20.15,28.53,28.53,0,0,0-3.85-7.93c-1.55-2.24-2.33-3.36-3.46-3.45-3-.24-6.19,7-7.52,11.66a40.21,40.21,0,0,0,.45,20.77C14,35.82,15,38.41,15,38.41c.74,1.9,1.17,2.53,2.05,4.87C18.75,47.88,19.31,50.39,20.41,50.41Z",
    transform: "translate(-1.09 -1.22)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7,15.86h5.19l3.42,8.92c.43,1.18.79,2.46,1.22,3.7h.13c.42-1.24.78-2.52,1.2-3.7l3.31-8.92h5.2V35.92H69V28.56a67.54,67.54,0,0,1,.61-6.81h-.13l-1.73,4.74-3,7.69H62.16l-3-7.69-1.68-4.74h-.13A67.54,67.54,0,0,1,58,28.56v7.36H53.7Z",
    transform: "translate(-1.09 -1.22)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.85,15.86h5.7l6.62,20.06h-5L89.37,25.76c-.59-2-1.15-4.38-1.71-6.47h-.13c-.51,2.12-1.07,4.47-1.66,6.47L83.1,35.92H78.23ZM82.59,27.62H92.73v3.52H82.59Z",
    transform: "translate(-1.09 -1.22)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.43,26c0-6.66,4.65-10.52,10.27-10.52a9.37,9.37,0,0,1,6.65,2.61L113.84,21a5.57,5.57,0,0,0-4-1.6c-3.24,0-5.54,2.42-5.54,6.45s2,6.52,5.92,6.52a4,4,0,0,0,2.24-.6V28.32H109V24.61h7.73v9.25a10.52,10.52,0,0,1-7,2.43C104,36.29,99.43,32.76,99.43,26Z",
    transform: "translate(-1.09 -1.22)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M122.36,15.86h5.19L131,24.78c.42,1.18.79,2.46,1.22,3.7h.12c.43-1.24.78-2.52,1.21-3.7l3.31-8.92H142V35.92h-4.34V28.56a67.54,67.54,0,0,1,.61-6.81h-.13l-1.73,4.74-3,7.69h-2.64l-3-7.69-1.68-4.74H126c.22,1.94.61,4.85.61,6.81v7.36h-4.27Z",
    transform: "translate(-1.09 -1.22)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153.51,15.86h5.7l6.62,20.06h-5.05L158,25.76c-.59-2-1.15-4.38-1.71-6.47h-.13c-.51,2.12-1.08,4.47-1.66,6.47l-2.77,10.16h-4.87Zm-2.26,11.76h10.14v3.52H151.25Z",
    transform: "translate(-1.09 -1.22)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.58,41.55h1.11l1.38,3.86c.18.49.34,1,.51,1.5h.05c.17-.5.32-1,.5-1.5l1.37-3.86h1.1v7.22h-.85v-4c0-.63.07-1.5.11-2.14h0l-.57,1.65L56.89,48h-.61l-1.37-3.73-.57-1.65h0c0,.64.11,1.51.11,2.14v4h-.83Z",
    transform: "translate(-1.09 -1.22)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.16,47.38c0-1.16,1-1.75,3.29-2,0-.69-.23-1.35-1.11-1.35a2.93,2.93,0,0,0-1.59.57L61.39,44a4,4,0,0,1,2.1-.7c1.31,0,1.86.87,1.86,2.2v3.28H64.6l-.07-.64h0a2.82,2.82,0,0,1-1.77.77A1.45,1.45,0,0,1,61.16,47.38Zm3.29.09V46c-1.8.22-2.4.65-2.4,1.34s.41.85.94.85A2.23,2.23,0,0,0,64.45,47.47Z",
    transform: "translate(-1.09 -1.22)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4,46.81V43.42h.91v3.27c0,1,.3,1.43,1,1.43.55,0,.92-.27,1.43-.9v-3.8h.91v5.35h-.75l-.08-.84h0a2.25,2.25,0,0,1-1.76,1C67.91,48.9,67.4,48.18,67.4,46.81Z",
    transform: "translate(-1.09 -1.22)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.68,43.42h.75l.07,1h0a1.83,1.83,0,0,1,1.52-1.11,1.26,1.26,0,0,1,.57.11l-.17.79a1.77,1.77,0,0,0-.52-.08c-.45,0-1,.32-1.35,1.23v3.43h-.91Z",
    transform: "translate(-1.09 -1.22)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.77,41.74a.59.59,0,0,1,.63-.59.59.59,0,1,1,0,1.17A.59.59,0,0,1,77.77,41.74Zm.17,1.68h.9v5.35h-.9Z",
    transform: "translate(-1.09 -1.22)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.58,47.12v-3h-.79v-.69l.83,0,.11-1.5h.76v1.5h1.45v.74H81.49v3c0,.66.21,1,.82,1a1.82,1.82,0,0,0,.61-.15l.18.69a3.28,3.28,0,0,1-1,.19C81,48.9,80.58,48.18,80.58,47.12Z",
    transform: "translate(-1.09 -1.22)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2,41.74a.58.58,0,0,1,.62-.59.59.59,0,1,1-.62.59Zm.16,1.68h.91v5.35h-.91Z",
    transform: "translate(-1.09 -1.22)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.21,46.81V43.42h.91v3.27c0,1,.3,1.43,1,1.43.55,0,.92-.27,1.43-.9v-3.8h.91v5.35h-.75l-.08-.84h0a2.25,2.25,0,0,1-1.76,1C87.72,48.9,87.21,48.18,87.21,46.81Z",
    transform: "translate(-1.09 -1.22)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M93.12,48.16l.44-.6a2.41,2.41,0,0,0,1.58.64c.7,0,1-.38,1-.83s-.63-.8-1.22-1c-.75-.27-1.59-.64-1.59-1.54s.68-1.52,1.84-1.52a2.67,2.67,0,0,1,1.66.6l-.43.58A2,2,0,0,0,95.23,44c-.67,0-1,.35-1,.76s.58.7,1.18.93c.78.29,1.63.61,1.63,1.62s-.68,1.59-2,1.59A3.19,3.19,0,0,1,93.12,48.16Z",
    transform: "translate(-1.09 -1.22)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M100.19,45.17c0-2.33,1.4-3.75,3.31-3.75a2.78,2.78,0,0,1,2.08.89l-.5.6a2,2,0,0,0-1.56-.68c-1.45,0-2.39,1.11-2.39,2.91s.86,3,2.4,3a1.93,1.93,0,0,0,1.3-.42V45.79h-1.52V45h2.36v3a3,3,0,0,1-2.22.84C101.54,48.9,100.19,47.51,100.19,45.17Z",
    transform: "translate(-1.09 -1.22)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.31,47.7V40.93h.9v6.83c0,.28.12.39.25.39l.2,0,.13.69a1.69,1.69,0,0,1-.53.08C107.59,48.9,107.31,48.47,107.31,47.7Z",
    transform: "translate(-1.09 -1.22)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M109.71,46.1a2.5,2.5,0,1,1,5,0,2.5,2.5,0,1,1-5,0Zm4,0c0-1.22-.63-2.06-1.55-2.06s-1.54.84-1.54,2.06.62,2,1.54,2S113.74,47.33,113.74,46.1Z",
    transform: "translate(-1.09 -1.22)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M116.87,48.22h0l-.09.55H116V40.93h.91v2.15l0,1a2.64,2.64,0,0,1,1.68-.75c1.38,0,2.12,1.07,2.12,2.72,0,1.83-1.09,2.89-2.32,2.89A2.37,2.37,0,0,1,116.87,48.22Zm2.9-2.2c0-1.18-.4-2-1.41-2a2.15,2.15,0,0,0-1.42.73v2.81a2.07,2.07,0,0,0,1.3.55C119.12,48.14,119.77,47.34,119.77,46Z",
    transform: "translate(-1.09 -1.22)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M122.08,47.38c0-1.16,1-1.75,3.28-2,0-.69-.23-1.35-1.1-1.35a2.9,2.9,0,0,0-1.59.57l-.36-.62a3.94,3.94,0,0,1,2.1-.7c1.31,0,1.86.87,1.86,2.2v3.28h-.75l-.08-.64h0a2.79,2.79,0,0,1-1.76.77A1.45,1.45,0,0,1,122.08,47.38Zm3.28.09V46c-1.79.22-2.4.65-2.4,1.34s.42.85.94.85A2.19,2.19,0,0,0,125.36,47.47Z",
    transform: "translate(-1.09 -1.22)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M128,47.7V40.93h.91v6.83c0,.28.12.39.25.39l.2,0,.12.69a1.62,1.62,0,0,1-.52.08C128.23,48.9,128,48.47,128,47.7Z",
    transform: "translate(-1.09 -1.22)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M133,41.55h1.11l1.38,3.86c.18.49.34,1,.52,1.5h0c.17-.5.33-1,.5-1.5L138,41.55h1.1v7.22h-.85v-4c0-.63.07-1.5.12-2.14h-.05l-.57,1.65L136.35,48h-.61l-1.36-3.73-.58-1.65h0c0,.64.12,1.51.12,2.14v4H133Z",
    transform: "translate(-1.09 -1.22)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M140.62,47.38c0-1.16,1-1.75,3.29-2,0-.69-.23-1.35-1.11-1.35a3,3,0,0,0-1.59.57l-.35-.62a3.94,3.94,0,0,1,2.1-.7c1.3,0,1.85.87,1.85,2.2v3.28h-.74l-.08-.64h0a2.82,2.82,0,0,1-1.77.77A1.46,1.46,0,0,1,140.62,47.38Zm3.29.09V46c-1.79.22-2.4.65-2.4,1.34s.41.85.94.85A2.23,2.23,0,0,0,143.91,47.47Z",
    transform: "translate(-1.09 -1.22)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M146.5,43.42h.75l.07,1h0a1.85,1.85,0,0,1,1.52-1.11,1.21,1.21,0,0,1,.57.11l-.16.79a1.77,1.77,0,0,0-.52-.08c-.46,0-1,.32-1.36,1.23v3.43h-.9Z",
    transform: "translate(-1.09 -1.22)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M151,40.93h.89v5.31h0l2.28-2.82h1l-1.79,2.15,2,3.2h-1l-1.56-2.57-1,1.17v1.4H151Z",
    transform: "translate(-1.09 -1.22)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M156.24,46.1a2.58,2.58,0,0,1,2.41-2.81c1.36,0,2.13,1,2.13,2.51a2.51,2.51,0,0,1,0,.51h-3.6a1.78,1.78,0,0,0,1.78,1.87,2.29,2.29,0,0,0,1.33-.43l.32.6a3.13,3.13,0,0,1-1.77.55A2.56,2.56,0,0,1,156.24,46.1Zm3.74-.43c0-1.08-.48-1.66-1.32-1.66a1.65,1.65,0,0,0-1.53,1.66Z",
    transform: "translate(-1.09 -1.22)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M162.15,47.12v-3h-.8v-.69l.84,0,.11-1.5h.75v1.5h1.45v.74h-1.45v3c0,.66.21,1,.83,1a1.88,1.88,0,0,0,.61-.15l.17.69a3.28,3.28,0,0,1-1,.19C162.53,48.9,162.15,48.18,162.15,47.12Z",
    transform: "translate(-1.09 -1.22)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M169.25,41.55h1l2.44,7.22h-1l-1.26-4c-.26-.81-.49-1.6-.72-2.44h0c-.23.84-.46,1.63-.72,2.44l-1.27,4h-.94Zm-1.15,4.29h3.32v.73H168.1Z",
    transform: "translate(-1.09 -1.22)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M173.05,46.1a2.6,2.6,0,0,1,2.58-2.81,2.24,2.24,0,0,1,1.56.63l-.46.6a1.56,1.56,0,0,0-1.06-.48c-1,0-1.68.84-1.68,2.06s.67,2,1.65,2a2,2,0,0,0,1.26-.53l.39.6a2.6,2.6,0,0,1-1.73.68A2.52,2.52,0,0,1,173.05,46.1Z",
    transform: "translate(-1.09 -1.22)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M177.84,46.1a2.59,2.59,0,0,1,2.57-2.81,2.22,2.22,0,0,1,1.56.63l-.46.6a1.56,1.56,0,0,0-1.06-.48c-1,0-1.68.84-1.68,2.06s.67,2,1.66,2a1.93,1.93,0,0,0,1.25-.53l.39.6a2.57,2.57,0,0,1-1.72.68A2.51,2.51,0,0,1,177.84,46.1Z",
    transform: "translate(-1.09 -1.22)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M182.62,46.1a2.5,2.5,0,1,1,5,0,2.5,2.5,0,1,1-5,0Zm4,0c0-1.22-.62-2.06-1.54-2.06s-1.54.84-1.54,2.06.62,2,1.54,2S186.64,47.33,186.64,46.1Z",
    transform: "translate(-1.09 -1.22)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M189.13,46.81V43.42h.9v3.27c0,1,.31,1.43,1,1.43s.93-.27,1.43-.9v-3.8h.91v5.35h-.75l-.07-.84h0a2.26,2.26,0,0,1-1.77,1C189.64,48.9,189.13,48.18,189.13,46.81Z",
    transform: "translate(-1.09 -1.22)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M195.4,43.42h.75l.08.77h0a2.55,2.55,0,0,1,1.79-.9c1.13,0,1.63.73,1.63,2.09v3.39h-.9V45.5c0-1-.3-1.42-1-1.42-.55,0-.92.28-1.46.82v3.87h-.91Z",
    transform: "translate(-1.09 -1.22)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M201.58,47.12v-3h-.79v-.69l.83,0,.11-1.5h.76v1.5h1.44v.74h-1.44v3c0,.66.21,1,.82,1a1.82,1.82,0,0,0,.61-.15l.18.69a3.29,3.29,0,0,1-1,.19C202,48.9,201.58,48.18,201.58,47.12Z",
    transform: "translate(-1.09 -1.22)"
  })));
}

export default __webpack_public_path__ + "media/ccf38570.svg";
export { SvgLogo as ReactComponent };